export default __webpack_public_path__ + "static/media/icon-Table-Close.c17b7d20.svg";